'use client'
import React, { useState, useRef, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { ChevronDown } from 'lucide-react'

import useClickOutside from 'src/app/hooks/useClickOustide'
import Image from 'next/image'
const SearchSection = ({ formData, setFormData, handleCurrencyChange, t }) => {
  const [isFocus, setIsFocus] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)
  const parentRef = useRef(null)
  useClickOutside(dropdownRef, parentRef, () => setIsOpen(false))
  const {
    register,
    watch,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      search: 'London, UK',
      dropdown: {
        name: 'GBP',
        sign: '£',
        label: '£ GBP',
        value: 'currency_gbp',
      },
    },
  })
  const getFormattedAddress = (place) => {
    setValue('search', place.formatted_address)
    //@params: place - Google Autocomplete place object
    //@returns: location_obj - An address object in human readable format
    let location_obj = {}
    for (let i in place.address_components) {
      let item = place.address_components[i]
      location_obj['formatted_address'] = place.formatted_address
      if (item['types'].indexOf('locality') > -1) {
        location_obj['locality'] = item['long_name']
      } else if (item['types'].indexOf('route') > -1) {
        location_obj['route'] = item['long_name']
      } else if (item['types'].indexOf('country') > -1) {
        location_obj['country'] = item['long_name']
      } else if (item['types'].indexOf('postal_code') > -1) {
        location_obj['postal_code'] = item['short_name']
      }
    }
    let country = (
      findItemAddressComponent(place.address_components, 'country') || {}
    ).short_name
    let state = (
      findItemAddressComponent(
        place.address_components,
        'administrative_area_level_1'
      ) ||
      findItemAddressComponent(
        place.address_components,
        'administrative_area_level_2'
      ) ||
      {}
    ).short_name
    let city = (findCityName(place.address_components) || {}).short_name
    let coordinates = place.geometry.location.toJSON()
    location_obj['coordinates'] = `${coordinates.lat.toFixed(
      4
    )}/${coordinates.lng.toFixed(4)}`
    // location_obj['address'] = `${city ? `${city}-${state}-${country}` : place.address_components[0].long_name}`
    location_obj['address'] = `${city}-${state}-${country}`
    location_obj['placeId'] = place.place_id
    return location_obj
  }
  const findItemAddressComponent = (address_components, level) => {
    return address_components.find((item) => item.types.includes(level))
  }
  const findCityName = (address_components) => {
    return address_components.find(
      (item) =>
        (item.types.includes('locality') && item.types.includes('political')) ||
        item.types.includes('postal_town')
    )
  }
  const searchValue = watch('search')
  const dropdownValue = watch('dropdown')

  const handleSearchChange = async (e) => {
    setValue('search', e.target.value)
    const autocomplete = new google.maps.places.Autocomplete(
      document.getElementById('search')
    )
    autocomplete.setTypes(['(cities)'])

    autocomplete.addListener('place_changed', () => {
      if (autocomplete.getPlace()) {
        setFormData({
          ...formData,
          addressObj: getFormattedAddress(autocomplete.getPlace()),
        })
      }
    })
  }

  const handleDropdownChange = (selectedItem , dropdownValue) => {
    if(dropdownValue.name === selectedItem.name) return
    setValue('dropdown', selectedItem)
    setIsOpen(false)
    handleCurrencyChange(selectedItem)
  }

  // useEffect(() => {
  //   if(dropdownValue){
  //     }
  // }, [dropdownValue])

  const currency = [
    { name: 'GBP', sign: '£', label: '£ GBP', value: 'currency_gbp' },
    { name: 'EUR', sign: '€', label: '€ EUR', value: 'currency_eur' },
    { name: 'USD', sign: '$', label: '$ USD', value: 'currency_usd' },
    { name: 'AED', sign: 'د.إ', label: 'د.إ AED', value: 'currency_aed' },
  ]

  return (
    <div className='grid grid-cols-1 md:grid-cols-12 gap-4'>
      {/* <div className='flex col-span-full md:col-span-6 flex-col gap-4 md:flex-row items-center'> */}
        <div className='flex flex-1 col-span-5 lg:col-span-5 items-center text-[15px] relative rounded-[5px] border gap-5 px-[10.5px] font-light border-[#e0e0e0] py-[10px]'>
          <label
            className={`absolute ${
              !searchValue && !isFocus
                ? 'top-1/2 translate-y-[-50%] scale-100 text-rolzo-black'
                : 'scale-75 top-0 translate-y-[-9px] text-rolzo-grey'
            } transition-all  duration-300 left-[30px] bg-white px-5 pointer-events-none`}
            htmlFor='search'
          >
            {t('searchBar.placeholder')}
          </label>
          <div className='w-[29.5px]'>
            <Image
              src='/images/searchIcon.svg'
              alt='explore rolzo fleet around the world'
              width={24}
              height={24}
            />
          </div>
          <input
            id='search'
            defaultValue='London, UK'
            className='focus:outline-none caret-[#a79779] flex-1'
            {...register('search', { required: 'Search is required' })}
            onChange={handleSearchChange}
            onFocus={() => setIsFocus(true)}
            onBlur={() => setIsFocus(false)}
            placeholder=''
          />
          {errors.search && (
            <p className='text-red-500 text-sm'>{errors.search.message}</p>
          )}
        </div>

        <div className='relative h-full col-span-3 lg:col-span-3 w-full md:w-fit '>
          <button
            ref={parentRef}
            className='px-5 h-full text-[14px] text-rolzo-black  hover:bg-[#f5f5f5] transition-colors duration-300 ease-in-out font-light py-4 md:py-2 border rounded-md text-left flex items-center bg-white focus:outline-none'
            onClick={() => setIsOpen((prev) => !prev)}
          >
            <ChevronDown
              color='#0c0c0c'
              size={21}
              strokeWidth='1'
              className='mr-2'
            />
            <p>
              {dropdownValue ? dropdownValue.label : 'Select an option'}
              </p>
          </button>

          {isOpen && (
            <ul
              ref={dropdownRef}
              className='absolute rounded-md mt-1 border-[#ccc] border-[0.5px] bg-white p-4 flex flex-col gap-2 w-full z-10 '
            >
              {currency.map((item, index) => (
                <li
                  key={item.value}
                  className={`cursor-pointer flex items-center gap-2
                      `}
                  onClick={() => handleDropdownChange(item ,dropdownValue)}
                >
                  <input
                    type='radio'
                    id={`option-${index}`}
                    name='dropdown'
                    value={item.value}
                    checked={dropdownValue?.value === item.value}
                    readOnly
                    className='mr-2 hidden'
                  />
                  <div
                    className={`size-4 border rounded-full group flex items-center relative justify-center border-rolzo-black`}
                  >
                    <div className='size-10 bg-black opacity-[0.04] group-hover:block hidden absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 rounded-full'></div>

                    {dropdownValue.value === item.value && (
                      <div className='size-[4.8px] bg-rolzo-black absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 rounded-full'></div>
                    )}
                  </div>
                  <label
                    className='text-[14px] pointer-events-none font-light text-[#0c0c0c]'
                    htmlFor={`option-${index}`}
                  >
                    {item.label}
                  </label>
                </li>
              ))}
            </ul>
          )}
          {errors.dropdown && (
            <p className='text-red-500'>{errors.dropdown.message}</p>
          )}
        </div>
      {/* </div> */}
    </div>
  )
}

export default SearchSection
